import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import {
  FaMapMarked,
  FaBed,
  FaShareAlt,
  FaRegBookmark,
  FaBookmark,
  FaMapMarker,
  FaCameraRetro,
  FaRegEdit,
} from "react-icons/fa";
import { GoHome } from "react-icons/go";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LuUserSquare2 } from "react-icons/lu";
import {
  MdOutlineCalendarMonth,
  MdOutlinePhone,
  MdNoteAlt,
} from "react-icons/md";
import { RxDimensions } from "react-icons/rx";
import { TbLamp } from "react-icons/tb";
import Cookies from "js-cookie"; // Import js-cookie if not already imported
import Dropdown from "./CustomDropdown";
import { toast } from "react-toastify";
import { Wind, Building } from "lucide-react";
import Photos_Video from "./Photos_Video";
import apiClient from "../common/apiClient";
import { useLocation } from "react-router-dom";
import ShareModal from "./ShareModal";
import OwnerStatusControl from "./Ownerdashboard/OwnerStatusControl";
import OwnerAddMediaButton from "./Ownerdashboard/OwnerAddMediaButton";
import apartmentsIcon from "../assets/apartments.png";
import officeBuildingIcon from "../assets/office-building.png";

const chipStyle =
  "inline-block px-3 py-1 m-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700";

// PRObroker support line an owner messages about a listing of theirs.
const SUPPORT_WHATSAPP_NUMBER = "917433881781";

const WhatsAppIcon = ({ className = "h-5 w-5", fill = "#25D366" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    className={className}
    fill={fill}
  >
    <path d="M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z" />
  </svg>
);

function List({
  property,
  requirement,
  fetchProperties,
  onSaveStatusChange,
  contactInfoMap = {},
  setContactInfoMap = () => { },
  topHeader,
  // Owner dashboard reuses this card, but an owner has no broker session - the
  // status/share/save/contact/remark actions all need one, so they are hidden.
  ownerView = false,
  // Owner-only: opens the edit form for this property.
  onEdit,
  // Owner-only: fires after a card status change is saved, so the list reloads.
  onStatusUpdated,
  // Owner-only: fires after photos are added to this property.
  onMediaUpdated,
}) {
  const location = useLocation();

  // Define isSpecialPath - check both URL and property type
  const isSpecialPath =
    location.pathname.includes("residential-rental/broker") ||
    location.pathname.includes("residential-rental/builder") ||
    property?.propertyType === "broker";

  // In the List component, add a check for requirement URL and property type
  const isRequirementPath =
    location.pathname.includes("residential-rental/requirement") ||
    property?.propertyType === "requirement" ||
    requirement === true;

  // State to handle show more/less
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSaved, setIsSaved] = useState(property?.isSaved);
  const [showDescMore, setShowDescMore] = useState(false);
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [contactError, setContactError] = useState(null);
  const [remark, setRemark] = useState(property?.remark || ""); // State for the remark
  const [isEditing, setIsEditing] = useState(false); // Toggle for editing
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentShareText, setCurrentShareText] = useState("");
  const [status, setStatus] = useState(
    isSpecialPath
      ? property?.propertyCurrentStatus || "available"
      : property?.status || "Active"
  ); // State for status
  const [previousStatus, setPreviousStatus] = useState(
    isSpecialPath
      ? property?.propertyCurrentStatus || "available"
      : property?.status || ""
  );

  const cardRef = useRef(null);
  const userId = Cookies.get("userId");
  const brokerName = Cookies.get("name");
  const brokerNumber = Cookies.get("number");
  const companyName = Cookies.get("companyName");

  // The chat opens pre-filled so support knows which listing is being reported.
  const supportWhatsAppLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(
    `Hello PRObroker, I have an issue with my property "${property?.title || "NA"
    }" (ID: ${property?.propertyId || "NA"}). Please help.`
  )}`;

  // Update status when property changes
  useEffect(() => {
    // setContactInfo(property);

    if (property?.status) {
      setStatus(property.status);
      setPreviousStatus(property.status);
    }
  }, [property]);

  // Screenshot protection effect - only for this card
  useEffect(() => {
    const cardElement = cardRef.current;
    if (!cardElement) return;

    // Track if window loses focus (possible screenshot)
    let blurTime = null;
    const handleBlur = () => {
      blurTime = Date.now();
    };

    const handleFocus = () => {
      // If window was blurred for a short time (likely screenshot), show warning
      if (blurTime && Date.now() - blurTime < 2000) {
        const isCardHovered = cardElement.matches(':hover');
        if (isCardHovered) {
          toast.error("Screenshots are not allowed", {
            position: "top-center",
            autoClose: 3000,
          });
        }
      }
      blurTime = null;
    };

    const handleKeyDown = (e) => {
      // Only handle if this card is focused or contains the active element
      const isCardActive = cardElement.contains(document.activeElement) || 
                          cardElement.matches(':hover');
      if (!isCardActive) return;

      // Block PrintScreen key (try multiple key codes)
      if (e.key === "PrintScreen" || e.code === "PrintScreen" || e.keyCode === 44) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        // Clear clipboard
        navigator.clipboard.writeText("").catch(() => {});
        return false;
      }
      // Block Ctrl+Shift+S (Windows screenshot tool)
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        return false;
      }
      // Block Ctrl+Shift+4/5 (Mac screenshot shortcuts)
      if (e.ctrlKey && e.shiftKey && (e.key === "4" || e.key === "5")) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        return false;
      }
      // Block Cmd+Shift+3/4/5 (Mac screenshot)
      if ((e.metaKey || e.key === "Command") && e.shiftKey && ["3", "4", "5"].includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        return false;
      }
    };

    const handleKeyUp = (e) => {
      // Only handle if this card is focused or contains the active element
      const isCardActive = cardElement.contains(document.activeElement) || 
                          cardElement.matches(':hover');
      if (!isCardActive) return;

      // Also check on keyup for PrintScreen (some browsers fire it here)
      if (e.key === "PrintScreen" || e.code === "PrintScreen" || e.keyCode === 44) {
        e.preventDefault();
        e.stopPropagation();
        toast.error("Screenshots are not allowed");
        // Attempt to clear clipboard
        navigator.clipboard.writeText("").catch(() => {});
        return false;
      }
    };

    // Prevent copy/paste/cut - only within this card
    const preventCopy = (e) => {
      if (!cardElement.contains(e.target)) return;
      e.preventDefault();
      toast.error("Copying is not allowed");
      return false;
    };

    // Prevent drag and drop - only within this card
    const preventDrag = (e) => {
      if (!cardElement.contains(e.target)) return;
      e.preventDefault();
      return false;
    };

    // Disable right-click - only within this card
    const preventContextMenu = (e) => {
      if (!cardElement.contains(e.target)) return;
      e.preventDefault();
      return false;
    };

    // Add event listeners
    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);
    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("keyup", handleKeyUp, true);
    document.addEventListener("copy", preventCopy, true);
    document.addEventListener("cut", preventCopy, true);
    document.addEventListener("dragstart", preventDrag, true);
    document.addEventListener("drop", preventDrag, true);
    document.addEventListener("contextmenu", preventContextMenu, true);

    return () => {
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("keyup", handleKeyUp, true);
      document.removeEventListener("copy", preventCopy, true);
      document.removeEventListener("cut", preventCopy, true);
      document.removeEventListener("dragstart", preventDrag, true);
      document.removeEventListener("drop", preventDrag, true);
      document.removeEventListener("contextmenu", preventContextMenu, true);
    };
  }, []);

  // BUILDER PRICE HANDLING
  const getBuilderPrice = (property) => {
    if (!property?.priceRange) return "NA";

    const min = property.priceRange?.min;
    const max = property.priceRange?.max;

    // No values
    if (!min && !max) return "NA";

    // Only min
    if (min && !max) return formatPrice(min);

    // Only max
    if (!min && max) return formatPrice(max);

    // Both present
    if (min === max) {
      return formatPrice(min);
    }

    return `${formatPrice(min)} - ${formatPrice(max)}`;
  };

  const handlePhotoClick = () => {
    toast.info("Photo button clicked! (Add your functionality here)");
  };

  const handleSaveRemark = async () => {
    try {
      const payload = {
        userId: userId,
        propId: property?._id,
        remark: remark,
      };

      // Fetch API call to save the remark
      const response = await fetch(
        `${process.env.REACT_APP_API_IP}/cjidnvij/ceksfbuebijn/user/jcebduvhd/vehbvyubheud/property-remark`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      // console.log("This is First Api", response);

      // Parse the response
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update remark.");
      }

      const result = await response.json();

      if (result.success) {
        toast.success("Remark updated successfully!");
        setIsEditing(false); // Exit edit mode
      } else {
        toast.error(
          result.message || "Failed to update remark. Please try again."
        );
      }
    } catch (error) {
      // console.error("Error saving remark:", error);
      toast.error(
        error.message || "An error occurred while saving the remark."
      );
    }
  };

  function openInGoogleMaps(address) {
    if (!address) return;

    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(mapsUrl, "_blank", "noopener,noreferrer");
  }

  const handleCancelEdit = () => {
    setIsEditing(false); // Exit edit mode
    setRemark(property?.remark || ""); // Reset remark to original value
  };

  // Save and UnSave
  const handleSaveClick = async () => {
    try {
      let response;

      // Check if we're on the requirements path
      if (isRequirementPath) {
        // Use the saveRequirements endpoint for requirements
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/saveRequirements",
          {
            userId: userId,
            requirementId: property._id,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        );
      } else if (isSpecialPath) {
        // Use the saveProperties endpoint for special path
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/saveProperties",
          {
            userId: userId,
            propertyId: property._id,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        );
      } else {
        // Use the regular save-property endpoint for properties
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/save-property/ijddskjidns/cudhsbcuev",
          {
            userId: userId,
            propId: property._id,
          }
        );
      }

      if (response.data.success) {
        // Update local state based on the response
        const isSaved = response.data.data.saved;
        setIsSaved(isSaved); // Assuming you have a state variable for saved status

        // Show success message
        toast.success(
          isSaved
            ? isRequirementPath
              ? "Requirement saved successfully"
              : "Property saved successfully"
            : isRequirementPath
              ? "Requirement unsaved successfully"
              : "Property unsaved successfully"
        );

        // If you have a callback to refresh the properties list
        if (typeof onSaveStatusChange === "function") {
          onSaveStatusChange(property._id, isSaved);
        }
      } else {
        toast.error(response.data.error || "Failed to update save status");
      }
    } catch (error) {
      // console.error("Error saving property:", error);
      toast.error("Failed to update save status. Please try again.");
    }
  };
  // const handleStatusChange = (newStatus) => {
  //   setStatus(newStatus);
  // };
  const handleStatusChange = async (newStatus) => {
    try {
      const path = location.pathname;

      const isBrokerOrBuilder =
        path.includes("residential-rental/broker") ||
        path.includes("residential-rental/builder");

      const isRequirementPath = path.includes("residential-rental/requirement");

      let response;

      if (isBrokerOrBuilder) {
        response = await apiClient(
          "put",
          `/cjidnvij/ceksfbuebijn/user/brokerproperties/${property._id}/status`,
          { status: newStatus },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );
      } else if (isRequirementPath) {
        response = await apiClient(
          "put",
          `/cjidnvij/ceksfbuebijn/user/brokerrequirements/${property._id}/status`, // make sure property._id is the requirementId
          { status: newStatus },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );
      } else {
        const data = {
          propId: property?._id,
          userId: userId,
          newStatus: newStatus,
          previousStatus: previousStatus,
          statusField: "status",
        };

        response = await apiClient(
          "post",
          `/cjidnvij/ceksfbuebijn/user/ckbwubuw/cjiwbucb/${property?._id}/status/cajbyqwvfydgqv`,
          data
        );
      }

      if (response?.data?.success) {
        setPreviousStatus(status);
        setStatus(newStatus);
        toast.success("Status updated successfully");
        if (typeof fetchProperties === "function") {
          setTimeout(fetchProperties, 100);
        }
      } else {
        toast.error(response?.data?.message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(
        error?.response?.data?.message ||
        error.message ||
        "Failed to update status"
      );
    }
  };

  const totalWord = 20;
  // check if description is too long
  const isDescriptionTooLong =
    property?.description?.split(" ").length > totalWord;

  // Function to truncate text to 20 words
  const truncateText = (text, wordLimit) => {
    const words = text?.split(" ");
    if (words?.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  const truncatedDescription = truncateText(property?.description, totalWord);

  // Check if the screen size is mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint in Tailwind
    };

    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Function to calculate days difference between two dates
  const calculateDaysDifference = (dateString) => {
    if (!dateString) return 0;
    const listedDate = new Date(dateString);
    const currentDate = new Date();
    const diffTime = currentDate - listedDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  // Function to format date with "X days before" logic
  function formatDate(dateString) {
    if (!dateString) return "NA";

    const daysDiff = calculateDaysDifference(dateString);
    const propertyType = property?.type;

     // Check for All propertyType - show "30 Days+" if >= 30 days old
    if ((propertyType === "Commercial Rent" || propertyType === "Commercial Sell" || propertyType === "Residential Sell" || propertyType === "Residential Rent") && daysDiff >= 30) {
      return "30 Days+";
    }

    // Check for Commercial Rent or Commercial Sell - show "90 days before" if >= 90 days old
    // if ((propertyType === "Residential Sell" || propertyType === "Commercial Sell") && daysDiff >= 30) {
    //   return "90 Days+";
    // }

    // Otherwise, show regular formatted date
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

 const getWhatsAppMessage = (property, contactInfo) => {
  const propertyName = property?.title || "Property";
  const type = property?.type || ""; 
  // examples: "Residential Rent", "Residential Sell", "Commercial Rent", "Commercial Sell"

  const isResidential = type.toLowerCase().includes("residential");
  const isCommercial = type.toLowerCase().includes("commercial");
  const isRent = type.toLowerCase().includes("rent");

  const action = isRent ? "Rent" : "Sale";

  const bhk = property?.bhk || "";
  const subType = property?.unitType || property?.subType || "";

  let firstLine = `Hello, is your ${propertyName} property available for ${action}?`;

  if (isResidential) {
    // Residential → add BHK + subtype
    // Example: Hello, is your Green Villa 2 BHK Flat property available for Rent?
    firstLine = `Hello, is your  ${bhk ? bhk : " "} ${subType} in ${propertyName} property available for ${action}?`;
  }

  if (isCommercial) {
    // Commercial → add only subtype
    // Example: Hello, is your Star Hub Office property available for Sale?
    firstLine = `Hello, is your  ${subType} in ${propertyName} property available for ${action}?`;
  }

  return `${firstLine}

Name: ${brokerName}
Number: ${brokerNumber}
Company: ${companyName}`;
};


  const handleShareClick = async (property) => {
    //   const handleShareClick = (property) => {

    // Create the share message
    const shareText = `
**${property?.type === "Residential Rent" || property?.type === "Residential Sell"
        ? `${property?.bhk || ""}${property?.bhk ? " " : ""}${property?.unitType || ""} Available for ${property?.type === "Residential Rent" ? "Rent" : "Sale"}`
        : property?.type === "Commercial Rent" || property?.type === "Commercial Sell"
          ? `${property?.unitType || ""} Available for ${property?.type === "Commercial Rent" ? "Rent" : "Sale"}`
          : "Property Available"
      }**

⦁ Premise: ${property?.title || "NA"}

⦁ Address: ${property?.area || "NA"}, ${property?.city || "NA"}

${isRequirementPath ? (
        property?.sizeRange?.sqFt ?
          `⦁ Square Ft: ${property.sizeRange.sqFt.min || 0}-${property.sizeRange.sqFt.max || 0} SqFt` :
          "⦁ Square Ft: N/A"
      ) : (
        `⦁ Square Ft: ${property?.sqFt || "NA"} SqFt`
      )}

⦁ Furnished Type: ${property?.furnishedType || "NA"}

${isRequirementPath ? (
        property?.priceRange ?
          `⦁ Price: ${formatPriceRange(property.priceRange)}` :
          "⦁ Price: N/A"
      ) : (
        property?.type === "Residential Rent" || property?.type === "Commercial Rent" ?
          `⦁ Rent: ${isSpecialPath ? "Rs. " + formatPrice(property?.price) : "Rs. " + formatPrice(property?.rentValue)}` :
          `⦁ Price: ${isSpecialPath ? "Rs. " + formatPrice(property?.price) : "Rs. " + formatPrice(property?.rentValue)}`
      )}

⦁ PID: ${isRequirementPath ? property.requirementId : property.propertyId}

**Name: ${brokerName || "NA"}**
**Number: ${brokerNumber || "NA"}**
`.trim();

    setCurrentShareText(shareText);
    setIsShareModalOpen(true);
  };



  useEffect(() => {
    if (property?.status) {
      setStatus(property.status);
      setPreviousStatus(property.status);
    }
  }, [property, isSpecialPath]);

  // Enhanced contact fetching function
  const handleGetContact = async () => {
    const propertyId = property._id;

    const isRequirementPath =
      location.pathname.includes("residential-rental/requirement") ||
      property?.propertyType === "requirement" ||
      requirement === true;

    // ✅ If already opened → close ALL
    if (contactInfoMap[propertyId]) {
      setContactInfoMap({});
      return;
    }

    setLoading(true);
    setContactError(null);

    try {
      let response;

      // ✅ REQUIREMENT
      if (isRequirementPath) {
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/broker-requirements/contact",
          { userId, requirementId: propertyId },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );
      }
      // ✅ BROKER / BUILDER
      else if (property?.listedBy === "broker" || property?.listedBy === "builders") {
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/broker-properties/contact",
          { userId, propId: propertyId, listedBy: property?.listedBy },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );
      }
      // ✅ DEFAULT
      else {
        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/v2/contacted/kcndjiwnjn/jdnjsnja/cxlbijbijsb",
          { userId, propId: propertyId }
        );
      }
   // ✅ Handle API Error (e.g. 429 Too Many Requests)
      if (!response.success) {
        if (response.status === 429) {
          const { blockedUntil, message } = response.error || {};

          if (blockedUntil) {
            const retryAfterMs = new Date(blockedUntil).getTime() - Date.now();
            const retryAfterSec = Math.ceil(retryAfterMs / 1000);

            toast.error(`Too many requests. Retry after ${retryAfterSec} seconds.`);
          } else {
            toast.error(message || "Too many requests. Please try again later.");
          }
          return;
        }

        setContactError(
          response.error?.message ||
          (typeof response.error === "string" ? response.error : "Failed to fetch contact info")
        );
        return;
      }   
      if (response.data.success) {
        const contactData = response.data.data;

        const contactInfo = {
          name:
            contactData.name ||
            contactData.brokerName ||
            contactData.ownerName ||
            "NA",
          number:
            contactData.contactNumber ||
            contactData.number ||
            contactData.ownerContact ||
            contactData.phone ||
            "NA",
        };

        // ✅ IMPORTANT → show only current
        setContactInfoMap({
          [propertyId]: contactInfo,
        });
      } else {
        setContactError(
          response.data.message || "Failed to fetch contact info"
        );
      }
    } catch (error) {
      console.error("Contact fetch error:", error);
      setContactError(
        error?.response?.data?.message || "Failed to fetch contact info"
      );
    } finally {
      setLoading(false);
    }
  };



  // Utility function to check if contact should be hidden
  const shouldHideContact = () => {
    const currentContactInfo = contactInfoMap[property._id];
    return (
      !currentContactInfo ||
      !currentContactInfo.number ||
      currentContactInfo.number === "0" ||
      currentContactInfo.number === ""
    );
  };

  // Utility function to show toast message
  const showToast = (message) => {
    const toast = document.createElement("div");
    toast.innerText = message;
    toast.style.position = "fixed";
    toast.style.bottom = "20px";
    toast.style.left = "50%";
    toast.style.transform = "translateX(-50%)";
    toast.style.backgroundColor = "#333";
    toast.style.color = "#fff";
    toast.style.padding = "10px 20px";
    toast.style.borderRadius = "5px";
    toast.style.zIndex = "1000";
    document.body.appendChild(toast);

    // Remove the toast after 3 seconds
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 3000);
  };

  const getStatusClassName = (status) => {
    switch (status) {
      case "Rentout":
        return "bg-green-500 text-white";
      case "Not Answer":
        return "bg-yellow-500 text-white";
      case "Renting":
        return "bg-blue-500 text-white"; // Example, you can adjust the color
      default:
        return "bg-white text-black"; // Default case
    }
  };

  // console.log("Property object:", property);
  // console.log("Property ID:", property?._id);

  // Function to format areas array into string
  const formatAreas = (areas) => {
    return areas ? areas.join(", ") : "NA";
  };

  // Function to format price range in lacs and crores
  const formatPrice = (price) => {
    if (!price || price === 0 || price === "0") return "Price On Request";

    // Convert to string for uniform handling
    const str = String(price).toLowerCase().trim();

    // Handle string-based inputs like "41 lacs" or "2.5 cr"
    if (str.includes("lac")) {
      const value = parseFloat(str);
      return `₹${value}${value % 1 === 0 ? "" : ""}Lac`;
    }
    if (str.includes("cr")) {
      const value = parseFloat(str);
      return `₹${value}${value % 1 === 0 ? "" : ""}Cr`;
    }

    // If numeric
    const num = Number(str.replace(/[^0-9.]/g, ""));
    if (isNaN(num)) return "NA";

    if (num >= 10000000) {
      const crValue = num / 10000000;
      return `₹${crValue % 1 === 0 ? Math.floor(crValue) : crValue.toFixed(2)
        }Cr`;
    }
    if (num >= 100000) {
      const lacValue = num / 100000;
      return `₹${lacValue % 1 === 0 ? Math.floor(lacValue) : lacValue.toFixed(2)
        }Lac`;
    }

    return `₹${num.toLocaleString("en-IN")}`;
  };
  const formatPriceRange = (priceRange) => {
    if (!priceRange) return "NA";

    const min = priceRange.min;
    const max = priceRange.max;

    // No values
    if (!min && !max) return "NA";

    // Only min
    if (min && !max) return formatPrice(min);

    // Only max
    if (!min && max) return formatPrice(max);

    // Both same
    if (min === max) return formatPrice(min);

    // Both exist
    return `${formatPrice(min)} - ${formatPrice(max)}`;
  };


  // Format requirement size range with unit (supports sqFt/sqft and sqYd/sqyd)
  const formatSizeRange = (sizeRange) => {
    if (!sizeRange) return { text: "NA", unit: "" };
    const sqFt = sizeRange.sqFt || sizeRange.sqft;
    const sqYd = sizeRange.sqYd || sizeRange.sqyd;
    const hasValues = (r) =>
      r && ((Number(r.min) || 0) > 0 || (Number(r.max) || 0) > 0);

    if (hasValues(sqFt)) {
      return {
        text: `${Number(sqFt.min) || 0} - ${Number(sqFt.max) || 0}`,
        unit: "SqFt",
      };
    }
    if (hasValues(sqYd)) {
      return {
        text: `${Number(sqYd.min) || 0} - ${Number(sqYd.max) || 0}`,
        unit: "SqYd",
      };
    }
    return { text: "NA", unit: "" };
  };

  // Function to format BHK options
  const formatbhk = (bhk) => {
    return bhk ? bhk.join(", ") : "NA";
  };

  // Function to format furnishing preferences
  const formatFurnishing = (furnishingPreferences) => {
    return furnishingPreferences ? furnishingPreferences.join(", ") : "NA";
  };

  // Add this function near the top of your component, after the state declarations
  const formatSpecialDescription = (property) => {
    const parts = [
      property?.description
        ? `Additional Description: ${property.description}`
        : null,
      property?.occupencyType && property.occupencyType.length > 0
        ? `Family Type: ${Array.isArray(property.occupencyType)
          ? property.occupencyType.join(", ")
          : property.occupencyType
        }`
        : null,
      property?.age ? `Age: ${property.age}` : null,
      property?.bathrooms ? `${property.bathrooms} Bathroom` : null,
      property?.unitType ? `Unit: ${property.unitType}` : null,
    ];

    const filteredParts = parts.filter(Boolean);
    return filteredParts.length > 0
      ? filteredParts.join(" | ")
      : "No additional details available";
  };

  return (
    <div 
      ref={cardRef}
      className="bg-white rounded-lg shadow-md p-2 lg:p-4 lg:mx-0 select-none"
      onCopy={(e) => {
        e.preventDefault();
        return false;
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        return false;
      }}
    >
      {topHeader && (
        <div className="pb-2 mb-2 border-b border-gray-100">
          {topHeader}
        </div>
      )}
      {/* Uncomment if you need the availability banner */}
      {/* <div className="flex flex-row items-center justify-end px-4 py-2">
        <div className="bg-yellow-300 rounded-lg p-1.5 text-white font-bold">
          Not Available
        </div>
      </div> */}

      {/* Desktop mode */}

      <div className="hidden lg:flex flex-wrap items-center justify-between gap-2 xl:gap-3 pt-4 px-2 xl:px-4">
        {/* Left: Date & ID */}
        <div className="flex flex-wrap items-center gap-1.5 xl:gap-2 min-w-0">
          <div className="relative group">
            <div
              className={`w-2.5 h-2.5 xl:w-3 xl:h-3 rounded-full ${property?.verifyStatus === "unverified"
                  ? "bg-yellow-400"
                  : "bg-green-500"
                }`}
            ></div>

            <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 w-max px-3 py-1 rounded bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 whitespace-nowrap shadow-md">
              {property?.verifyStatus === "unverified"
                ? "This property is unverified"
                : "This property is verified"}
            </div>
          </div>

          <div className="rounded-full text-red-500 font-bold px-2.5 xl:px-4 py-0.5 xl:py-1 border border-red-500 whitespace-nowrap text-xs xl:text-sm">
            {formatDate(property?.listedDate) || "NA"}
          </div>
          <div className="rounded-full text-blue-600 font-bold px-2.5 xl:px-4 py-0.5 xl:py-1 border border-blue-600 whitespace-nowrap text-xs xl:text-sm">
            ID:{" "}
            {isRequirementPath
              ? property?.requirementId
              : property?.propertyId || "NA"}
          </div>
        </div>

        {/* Title & Rent */}
        <div className="flex flex-wrap items-center gap-1.5 xl:gap-2 min-w-0 max-w-full justify-center">
          {isRequirementPath ? (
            <>
              <p className="text-[#503691] bg-[#EFE9FF] font-bold px-2.5 xl:px-4 py-1.5 xl:py-2 rounded-full border border-indigo-600 whitespace-nowrap text-xs xl:text-sm">
                {property?.type?.includes("Rent")
                  ? `Rent Range: ${formatPriceRange(property?.priceRange) || "NA"
                  }`
                  : property?.type?.includes("Sell")
                    ? `Price Range: ${formatPriceRange(property?.priceRange) || "NA"
                    }`
                    : "Type Not Available"}
              </p>
            </>
          ) : isSpecialPath ? (
            <>
              <p
                className="text-[#503691] bg-[#EFE9FF] font-bold px-2.5 xl:px-4 py-1.5 xl:py-2 rounded-full border border-indigo-600 truncate max-w-[140px] lg:max-w-[180px] xl:max-w-[260px] 2xl:max-w-[360px] cursor-pointer text-xs xl:text-sm"
                onClick={() =>
                  openInGoogleMaps(
                    `${property?.title || ""} ${property?.area || ""}`
                  )
                }
              >
                Premise - {property?.title || "NA"}
              </p>

              <p className="text-[#503691] bg-[#EFE9FF] font-bold px-2.5 xl:px-4 py-1.5 xl:py-2 rounded-full border border-indigo-600 whitespace-nowrap text-xs xl:text-sm">
                {property?.type?.includes("Rent")
                  ? `Rent: ${formatPrice(property?.price) || "NA"}`
                  : property?.type?.includes("Sell")
                    ? `Sell: ${formatPrice(property?.price) || "NA"}`
                    : "Type Not Available"}
              </p>
            </>
          ) : (
            <>
              <p
                className="text-[#503691] bg-[#EFE9FF] font-bold px-2.5 xl:px-4 py-1.5 xl:py-2 rounded-full border border-indigo-600 truncate max-w-[140px] lg:max-w-[180px] xl:max-w-[260px] 2xl:max-w-[360px] cursor-pointer text-xs xl:text-sm"
                onClick={() =>
                  openInGoogleMaps(
                    `${property?.title || ""} ${property?.area || ""}`
                  )
                }
              >
                Premise - {property?.title || "NA"}
              </p>

              <p className="text-[#503691] bg-[#EFE9FF] font-bold px-2.5 xl:px-3 py-1.5 xl:py-2 rounded-full border border-blue-700 text-xs xl:text-sm truncate flex-1 text-center min-w-0">
                {property?.listedBy === "builders"
                  ? `Price: ${getBuilderPrice(property)}`
                  : property?.type?.includes("Rent")
                    ? `Rent: ${formatPrice(property?.rentValue)}`
                    : property?.type?.includes("Sell")
                      ? `Sell: ${formatPrice(property?.rentValue)}`
                      : "Type Not Available"}
              </p>

            </>
          )}
        </div>

        {/* Action Buttons: Dropdown, Photo, Share, Save */}
        <div className="flex flex-wrap items-center gap-1.5 xl:gap-2 min-w-0">
          {!ownerView && (
            <Dropdown
              status={status}
              onChange={handleStatusChange}
              propertyType={property?.type}
            />
          )}

          {/* Owner-only "+" that adds photos, sitting left of the Media button */}
          {ownerView && (
            <OwnerAddMediaButton property={property} onUploaded={onMediaUpdated} />
          )}

          {/* Only show Photos button if not in requirements path */}
          {!isRequirementPath &&
            (property?.images?.length > 0 ||
              (isSpecialPath && property?.media?.length > 0) ? (
              <Photos_Video
                images={
                  isSpecialPath
                    ? property?.media?.map((item) => item.url) || []
                    : property.images?.length > 0
                      ? property.images[0].includes(",")
                        ? property.images[0].split(",")
                        : property.images
                      : []
                }
              />
            ) : (
              <div className="flex items-center gap-1.5 xl:gap-2 bg-gray-100 hover:bg-white text-gray-400 hover:text-blue-800 border border-gray-300 px-2 xl:px-3 py-1 xl:py-1.5 rounded-lg cursor-not-allowed text-xs xl:text-sm">
                <FaCameraRetro className="h-3.5 w-3.5 xl:h-4 xl:w-4 text-gray-400" />
                <span className="hidden lg:inline">Media</span>
              </div>
            ))}

          {ownerView && onEdit && (
            <div
              className="flex items-center gap-1.5 xl:gap-2 bg-[#503691] hover:bg-white text-white hover:text-[#503691] border border-[#503691] px-2.5 xl:px-3 py-1 xl:py-1.5 rounded-lg cursor-pointer text-xs xl:text-sm"
              onClick={() => onEdit(property)}
            >
              <FaRegEdit className="h-3.5 w-3.5 xl:h-4 xl:w-4" />
              <span>Edit Property</span>
            </div>
          )}

          {!ownerView && (
            <>
              <div
                className="flex items-center gap-1.5 xl:gap-2 bg-[#503691] hover:bg-white text-white hover:text-blue-800 border border-blue-800 px-2.5 xl:px-3 h-8 xl:h-10 rounded-lg cursor-pointer"
                onClick={() => handleShareClick(property)}
              >
                <FaShareAlt className="h-3.5 w-3.5 xl:h-4 xl:w-4" />
              </div>

              <div
                className={`flex items-center gap-1.5 xl:gap-2 border border-[#503691] px-2.5 xl:px-3 py-2 xl:py-2.5 rounded-lg cursor-pointer ${isSaved
                    ? "bg-white text-[#503691]"
                    : "bg-white text-[#503691] hover:bg-[#503691] hover:text-white"
                  }`}
                onClick={handleSaveClick}
              >
                {isSaved ? (
                  <FaBookmark className="h-3.5 w-3.5 xl:h-4 xl:w-4" />
                ) : (
                  <FaRegBookmark className="h-3.5 w-3.5 xl:h-4 xl:w-4" />
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Mobile mode */}
      <div className="grid grid-cols-1 lg:grid-cols-2 lg:hidden gap-2 items-center justify-between pt-4 px-1 lg:px-4">
        <div className="flex flex-col lg:flex-row justify-between gap-2">
          <div className="flex flex-row justify-between gap-2">
            {isRequirementPath ? (
              <>
                <p className="text-[#503691] bg-[#EFE9FF] font-bold px-3 py-2 rounded-full border border-blue-700 text-sm truncate flex-1 text-center min-w-0">
                  {property?.type?.includes("Rent")
                    ? `Rent Range: ${formatPriceRange(property?.priceRange) || "NA"
                    }`
                    : property?.type?.includes("Sell")
                      ? `Price Range: ${formatPriceRange(property?.priceRange) || "NA"
                      }`
                      : "Type Not Available"}
                </p>
              </>
            ) : isSpecialPath ? (
              <>
                <p
                  className="text-[#503691] bg-[#EFE9FF] font-bold px-2.5 py-2 rounded-full border text-sm border-blue-700 text-nowrap overflow-hidden text-ellipsis"
                  onClick={() =>
                    openInGoogleMaps(
                      `${property?.title || ""} ${property?.area || ""}`
                    )
                  }
                >
                  Premise - {property?.title || "NA"}
                </p>

                <p className="text-[#503691] bg-[#EFE9FF] font-bold px-3 py-2 rounded-full border border-blue-700 text-sm truncate flex-1 text-center min-w-0">
                  {property?.listedBy === "builders"
                    ? `Price: ${getBuilderPrice(property)}`
                    : property?.type?.includes("Rent")
                      ? `Rent: ${formatPrice(property?.price)}`
                      : property?.type?.includes("Sell")
                        ? `Sell: ${formatPrice(property?.price)}`
                        : "Type Not Available"}
                </p>

              </>
            ) : (
              <>
                <p
                  className="text-[#503691] bg-[#EFE9FF] font-bold px-2.5 py-2 rounded-full border text-sm border-blue-700 text-nowrap overflow-hidden text-ellipsis"
                  onClick={() =>
                    openInGoogleMaps(
                      `${property?.title || ""} ${property?.area || ""}`
                    )
                  }
                >
                  Premise - {property?.title || "NA"}
                </p>

                <p className="text-[#503691] bg-[#EFE9FF] font-bold px-3 py-2 rounded-full border border-blue-700 text-sm truncate flex-1 text-center min-w-0">
                  {property?.listedBy === "builders"
                    ? `Price: ${getBuilderPrice(property)}`
                    : property?.type?.includes("Rent")
                      ? `Rent: ${formatPrice(property?.rentValue)}`
                      : property?.type?.includes("Sell")
                        ? `Sell: ${formatPrice(property?.rentValue)}`
                        : "Type Not Available"}
                </p>

              </>
            )}
          </div>

          <div className="flex flex-row justify-between gap-2">
            <div className="flex flex-row gap-2 items-center">
              <div className="relative group">
                <div
                  className={`w-3 h-3 rounded-full ${property?.verifyStatus === "unverified"
                      ? "bg-yellow-400"
                      : "bg-green-500"
                    }`}
                ></div>

                <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 w-max px-3 py-1 rounded bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 whitespace-nowrap shadow-md">
                  {property?.verifyStatus === "unverified"
                    ? "This property is unverified"
                    : "This property is verified"}
                </div>
              </div>

              <div className="rounded-full bg-gray-100 p-2 text-sm text-red-500 font-bold px-4 py-1 w-fit ">
                {/* #{generateRandom6DigitNumber()} */}
                {formatDate(property?.listedDate) || "NA"}
              </div>

              <div className="rounded-full bg-gray-100 p-2 text-sm text-blue-600 font-bold px-4 py-1 w-fit ">
                ID: {property?.propertyId || "NA"}
              </div>
            </div>

            {/* <div className="bg-gray-100 rounded-full p-2   text-sm text-red-500 font-bold w-fit"> */}
            {/* #{generateRandom6DigitNumber()} */}
            {/* {formatDate(property?.listedDate) || "NA"}
            </div> */}
            {/* <div className="bg-gray-100 rounded-full p-2 text-sm text-blue-500 font-bold w-fit">
                ID: {property?.propertyId || "NA"}
            </div> */}
            {!ownerView && (
              <div>
                <Dropdown
                  status={status}
                  className="h-10"
                  onChange={handleStatusChange}
                  propertyType={property?.type}
                />{" "}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Main content area */}
      <div className="grid grid-cols-1 lg:grid-cols-2 text-xs lg:text-sm xl:text-md gap-3 xl:gap-4 p-2 lg:p-4 divide-x lg:divide-solid divide-none lg:divide-black">
        {/* First grid of items */}
        <div className="grid grid-cols-1 gap-1.5 xl:gap-2">
          {isRequirementPath && (
            <>
              <div className="flex items-center justify-between gap-2 xl:gap-4">
                <div className="flex flex-row items-center">
                  <Building className="mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6 text-[#503691]" />
                  <p className="text-xs xl:text-sm">Premise</p>
                </div>
                <p
                  className="text-end text-xs xl:text-sm font-medium hover:underline cursor-pointer"
                  onClick={() =>
                    openInGoogleMaps(
                      `${property?.title || ""} ${property?.area || ""}`
                    )
                  }
                >
                  {property?.title || "NA"}
                </p>
              </div>
              <hr className="block"></hr>
            </>
          )}
          <div className="flex items-center justify-between gap-2 xl:gap-4">
            <div className="flex flex-row items-center">
              <img src={apartmentsIcon} alt="" className="mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
              <p className="text-xs xl:text-sm">Type</p>
            </div>
            <p className="text-end text-xs xl:text-sm">{property?.type || "NA"}</p>
          </div>
          <hr className="block"></hr>

          {/* <div className="flex items-center justify-between gap-4">
            <div className="flex flex-row items-center">
              <LuUserSquare2 className="text-[#503691] mr-2 h-6 w-6" />
              <p>Name</p>
            </div>
            <p className="text-end">{property?.name || "NA"}</p>
          </div>
          <hr className="block"></hr> */}
          {/* <div className="flex items-center justify-between gap-4">
            <div className="flex flex-row items-center">
              <MdOutlineCalendarMonth className="text-[#f1d35c] mr-2 h-6 w-6" />
              <p>Date</p>
            </div>
            <p className="text-end">
              {formatDate(property?.createdOn) || "NA"}
            </p>
          </div> */}
          <div className="flex items-center justify-between gap-4">
            <div className="flex flex-row items-center">
              <img src={officeBuildingIcon} alt="" className="mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
              <p className="text-xs xl:text-sm">Subtype</p>
            </div>
            <p className="text-end text-xs xl:text-sm">
              {isRequirementPath
                ? property?.subType
                : property?.unitType || "NA"}
            </p>
          </div>
          <hr className="block"></hr>

          <div className="flex items-center justify-between gap-2 xl:gap-4">
            <div className="flex flex-row items-center">
              {/* <FaMapMarked className="text-[red] mr-2 h-6 w-6" /> */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22C11.7667 22 11.5667 21.9333 11.4 21.8C11.2333 21.6667 11.1083 21.4917 11.025 21.275C10.7083 20.3417 10.3083 19.4667 9.825 18.65C9.35833 17.8333 8.7 16.875 7.85 15.775C7 14.675 6.30833 13.625 5.775 12.625C5.25833 11.625 5 10.4167 5 9C5 7.05 5.675 5.4 7.025 4.05C8.39167 2.68333 10.05 2 12 2C13.95 2 15.6 2.68333 16.95 4.05C18.3167 5.4 19 7.05 19 9C19 10.5167 18.7083 11.7833 18.125 12.8C17.5583 13.8 16.9 14.7917 16.15 15.775C15.25 16.975 14.5667 17.975 14.1 18.775C13.65 19.5583 13.275 20.3917 12.975 21.275C12.8917 21.5083 12.7583 21.6917 12.575 21.825C12.4083 21.9417 12.2167 22 12 22ZM12 18.425C12.2833 17.8583 12.6 17.3 12.95 16.75C13.3167 16.2 13.85 15.4667 14.55 14.55C15.2667 13.6167 15.85 12.7583 16.3 11.975C16.7667 11.175 17 10.1833 17 9C17 7.61667 16.5083 6.44167 15.525 5.475C14.5583 4.49167 13.3833 4 12 4C10.6167 4 9.43333 4.49167 8.45 5.475C7.48333 6.44167 7 7.61667 7 9C7 10.1833 7.225 11.175 7.675 11.975C8.14167 12.7583 8.73333 13.6167 9.45 14.55C10.15 15.4667 10.675 16.2 11.025 16.75C11.3917 17.3 11.7167 17.8583 12 18.425ZM12 11.5C12.7 11.5 13.2917 11.2583 13.775 10.775C14.2583 10.2917 14.5 9.7 14.5 9C14.5 8.3 14.2583 7.70833 13.775 7.225C13.2917 6.74167 12.7 6.5 12 6.5C11.3 6.5 10.7083 6.74167 10.225 7.225C9.74167 7.70833 9.5 8.3 9.5 9C9.5 9.7 9.74167 10.2917 10.225 10.775C10.7083 11.2583 11.3 11.5 12 11.5Z"
                  fill="#1D1B20"
                />
              </svg>

              <p className="text-xs xl:text-sm">Area</p>
            </div>
            <div className="flex flex-wrap justify-end">
              {isRequirementPath ? (
                Array.isArray(property?.areas) ? (
                  property.areas.map((area, index) => (
                    <span key={index} className="inline-block px-2 xl:px-3 py-0.5 xl:py-1 m-0.5 xl:m-1 rounded-full text-xs xl:text-sm font-medium bg-gray-100 text-gray-700">
                      {area}
                    </span>
                  ))
                ) : (
                  <span className="inline-block px-2 xl:px-3 py-0.5 xl:py-1 m-0.5 xl:m-1 rounded-full text-xs xl:text-sm font-medium bg-gray-100 text-gray-700">NA</span>
                )
              ) : (
                <p className="text-gray-700 text-xs xl:text-sm">{property?.area || "NA"}</p>
              )}
            </div>
          </div>
          <hr className="block"></hr>

          {property?.type !== "Commercial Rent" &&
            property?.type !== "Commercial Sell" && (
              <div>
                <div className="flex items-center justify-between gap-2 xl:gap-4">
                  <div className="flex flex-row items-center">
                    <FaBed className="text-[#f1d35c] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
                    <p className="text-xs xl:text-sm">Size</p>
                  </div>
                  <div className="flex flex-wrap justify-end">
                    {isRequirementPath ? (
                      Array.isArray(property?.bhk) ? (
                        property.bhk.map((bhk, index) => (
                          <span key={index} className="inline-block px-2 xl:px-3 py-0.5 xl:py-1 m-0.5 xl:m-1 rounded-full text-xs xl:text-sm font-medium bg-gray-100 text-gray-700">
                            {bhk}
                          </span>
                        ))
                      ) : (
                        <span className="inline-block px-2 xl:px-3 py-0.5 xl:py-1 m-0.5 xl:m-1 rounded-full text-xs xl:text-sm font-medium bg-gray-100 text-gray-700">NA</span>
                      )
                    ) : (
                      <p className="text-gray-700 text-xs xl:text-sm">
                        {property?.bhk ? `${property.bhk}` : "NA"}
                      </p>
                    )}
                  </div>
                </div>
                <hr className="block"></hr>
              </div>
            )}


          <div className="lg:hidden flex items-center justify-between gap-2 xl:gap-4">
            <div className="flex flex-row items-center">
              <MdOutlineCalendarMonth className="text-[#f1d35c] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />

              <p className="text-xs xl:text-sm">
                {property?.type?.includes("Rent")
                  ? "Rent"
                  : property?.type?.includes("Sell")
                    ? "Sell"
                    : "Type Not Available"}
              </p>
            </div>

            <p className="text-end text-xs xl:text-sm">
              {property?.listedBy === "builders"
                ? `Price: ${getBuilderPrice(property)}`
                : property?.type?.includes("Rent")
                  ? `Rent: ${formatPrice(property?.rentValue)}`
                  : property?.type?.includes("Sell")
                    ? `Sell: ${formatPrice(property?.rentValue)}`
                    : "Type Not Available"}
            </p>
          </div>

          <hr className="lg:hidden block" />


          <div className="flex items-center justify-between gap-2 xl:gap-4">
            <div className="flex flex-row items-center">
              <TbLamp className="text-[#5f8de9] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
              <p className="text-xs xl:text-sm">Condition</p>
            </div>
            <p className="text-end text-xs xl:text-sm">
              {isRequirementPath
                ? formatFurnishing(property?.furnishingPreferences)
                : property?.furnishedType || "NA"}
            </p>
          </div>
        </div>

        {/* Second grid of items (conditionally rendered) */}
        {(showMore || !isMobile) && (
          <div className="grid grid-cols-1 gap-1.5 xl:gap-2 pl-0 lg:pl-4">
            <hr className="lg:hidden block"></hr>
            {/* <div className="flex items-center justify-between gap-4">
              <div className="flex flex-row items-center">
                <FaBed className="text-[#f1d35c] mr-2 h-6 w-6" />
                <p>Size</p>
              </div>
              <p className="text-end">{property?.bhk || "NA"}</p>
            </div> */}

            {/* Hide Address for requirements */}
            {!isRequirementPath && (
              <div>
                <div className="flex items-center justify-between gap-2 xl:gap-4">
                  <div className="flex flex-row items-center">
                    <GoHome className="text-[#247d00] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
                    <p className="text-xs xl:text-sm">Address</p>
                  </div>
                  <p className="text-end text-xs xl:text-sm">{property?.address || "NA"}</p>
                </div>
                <hr className="block"></hr>
              </div>
            )}
            <div className="flex items-center justify-between gap-2 xl:gap-4">
              <div className="flex flex-row items-center">
                <RxDimensions className="text-[#f1d35c] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
                <p className="text-xs xl:text-sm">Size</p>
              </div>
              <p className="text-end text-xs xl:text-sm">
                {isRequirementPath
                  ? (() => {
                    const fr = formatSizeRange(property?.sizeRange);
                    return fr.unit ? `${fr.text} ${fr.unit}` : fr.text;
                  })()
                  : `${property?.sqFt || "NA"} sqft`}
              </p>
            </div>
            <hr className="block"></hr>

            <div className="flex items-center justify-between gap-2 xl:gap-4">
              <div className="flex flex-row items-center">
                <IoDocumentTextOutline className="text-[#247d00] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
                <p className="text-xs xl:text-sm">Description</p>
                {/* {console.log("Property description:", property?.description)} */}
              </div>
              <p className="text-end text-xs xl:text-sm">
                {isSpecialPath ? (
                  <span>
                    {showDescMore
                      ? formatSpecialDescription(property)
                      : formatSpecialDescription(property)?.slice(0, 100)}{" "}
                    {/* truncate if needed */}
                    <span
                      className="text-blue-600 cursor-pointer hover:underline text-xs xl:text-sm ml-1"
                      onClick={() => setShowDescMore(!showDescMore)}
                    >
                      {showDescMore ? "Show Less" : "Show More"}
                    </span>
                  </span>
                ) : (
                  <span>
                    {showDescMore
                      ? property?.description
                      : truncatedDescription}
                    {isDescriptionTooLong && (
                      <span
                        className="text-blue-600 cursor-pointer hover:underline text-xs xl:text-sm ml-1"
                        onClick={() => setShowDescMore(!showDescMore)}
                      >
                        {showDescMore ? "Show Less" : "Show More"}
                      </span>
                    )}
                  </span>
                )}
              </p>
            </div>

            <hr className="block"></hr>
            {/* if we remove this it will remove extra line from mobile but remove one line from laptop view so remove from here but need to add something in mobile view */}
            {/* <div className="flex items-center justify-between gap-4">
              <div className="flex flex-row items-center">
                <TbLamp className="text-[#5f8de9] mr-2 h-6 w-6" />
                <p>Listed By</p>
              </div>
              <p className="text-end">{property?.userType || "NA"}</p>
            </div>
            <hr className="block"></hr> */}
            {/* Owner dashboard: status toggle sits where brokers see the contact */}
            {ownerView && (
              <div className="hidden lg:flex items-center justify-between gap-2 xl:gap-4">
                <div className="flex flex-col">
                  <div className="flex flex-row items-center">
                    <AiOutlineCheck className="text-[#503691] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
                    <p className="text-xs xl:text-sm">Property Status</p>
                  </div>
                  {property?.dailyContact !== undefined && (
                    <p className="text-xs text-gray-600 ml-7 xl:ml-8">
                      {property?.dailyContact} people contacted this property today
                    </p>
                  )}
                </div>

                <OwnerStatusControl property={property} onUpdated={onStatusUpdated} />
              </div>
            )}

            <div className={`${ownerView ? "hidden" : "lg:flex"} hidden items-center justify-between gap-2 xl:gap-4`}>
              <div className="flex flex-col">
                <div className="flex flex-row items-center">
                  <MdOutlinePhone className="text-[#503691] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
                  <p className="text-xs xl:text-sm">Contact</p>
                </div>
                {property?.dailyContact !== undefined && (
                  <p className="text-xs text-gray-600 ml-7 xl:ml-8">
                    {property?.dailyContact} people contacted this property today
                  </p>
                )}
              </div>

              {!contactInfoMap[property._id] ? (
                <button
                  onClick={handleGetContact}
                  className="bg-[#503691] text-white px-3 xl:px-4 py-1.5 xl:py-2 rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-xs xl:text-sm"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Get Contact Number"}
                </button>
              ) : (
                <div className="flex items-center justify-between py-1.5 xl:py-2 px-3 xl:px-4 rounded-lg bg-white text-[#503691] border border-gray-200">
                  {/* Contact Name and Number */}
                  <p className="font-medium text-xs xl:text-sm">
                    {contactInfoMap[property._id]?.name || "NA"} -{" "}
                    {contactInfoMap[property._id]?.number || "NA"}
                  </p>

                  {/* Icons for Phone and WhatsApp */}
                  <div className="flex items-center gap-2 xl:gap-3">
                    {/* Phone Link */}
                    <a
                      href={`tel:${typeof contactInfoMap[property._id]?.number ===
                          "string" &&
                          contactInfoMap[property._id]?.number.startsWith("+91")
                          ? contactInfoMap[property._id]?.number
                            .replace("+91", "")
                            .trim()
                          : contactInfoMap[property._id]?.number || ""
                        }`}
                      className="text-[#503691] hover:text-blue-600 transition-colors"
                      title="Call"
                    >
                      <MdOutlinePhone className="h-5 w-5 xl:h-6 xl:w-6" />
                    </a>

                    {/* WhatsApp Link */}
                    <a
                      href={`https://wa.me/${typeof contactInfoMap[property._id]?.number === "string" &&
                          contactInfoMap[property._id]?.number.startsWith("+91")
                          ? contactInfoMap[property._id]?.number.replace("+91", "").trim()
                          : contactInfoMap[property._id]?.number || ""
                        }?text=${encodeURIComponent(
                          getWhatsAppMessage(property, contactInfoMap[property._id])
                        )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:scale-110 transition-transform p-1 rounded-full hover:bg-green-100"
                      title="WhatsApp"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        className="h-6 w-6 xl:h-8 xl:w-8"
                        fill="#25D366"
                      >
                        <path d="M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z" />
                      </svg>
                    </a>
                  </div>
                </div>
              )}
            </div>
            {/* Remark Section */}
            {!ownerView && (
              <div>
                {" "}
                <hr className="block"></hr>
                <div className="lg:flex hidden items-center justify-between gap-2 xl:gap-4 mt-2 xl:mt-4">
                  <div className="flex flex-row items-center">
                    <MdNoteAlt className="text-[#503691] mr-1.5 xl:mr-2 h-5 w-5 xl:h-6 xl:w-6" />
                    <p className="text-xs xl:text-sm">Remark</p>
                  </div>
                  <div className="flex items-center justify-between py-1.5 xl:py-2 rounded-lg bg-white text-[#503691]">
                    {isEditing ? (
                      <div className="flex items-center gap-1.5 xl:gap-2">
                        <input
                          type="text"
                          value={remark}
                          onChange={(e) => setRemark(e.target.value)}
                          className="border p-1.5 xl:p-2 rounded w-full text-xs xl:text-sm"
                        />
                        <AiOutlineCheck
                          className="text-green-500 cursor-pointer h-4 w-4 xl:h-5 xl:w-5"
                          onClick={handleSaveRemark}
                        />
                        <AiOutlineClose
                          className="text-red-500 cursor-pointer h-4 w-4 xl:h-5 xl:w-5"
                          onClick={handleCancelEdit}
                        />
                      </div>
                    ) : (
                      <div className="flex items-center justify-between gap-1.5 xl:gap-2">
                        <p className="text-xs xl:text-sm">{remark || "Add a remark"}</p>
                        <button
                          className="text-blue-500 hover:underline text-xs xl:text-sm"
                          onClick={() => setIsEditing(true)}
                        >
                          Edit
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Show More/Less Button */}
      <div className="flex lg:hidden justify-start cursor-pointer text-md mb-2">
        <p
          onClick={() => setShowMore(!showMore)}
          className="text-blue-800 font-bold"
        >
          {isMobile && showMore ? "Show Less" : "Show More..."}
        </p>
      </div>

      <div className="flex flex-col lg:flex-2 lg:hidden justify-between gap-2">
        <div
          className={`grid gap-2 ${property.images && property.images.length > 0
              ? "grid-cols-3"
              : "grid-cols-3"
            }`}
        >
          {/* Share Button */}
          {!ownerView && (
            <div
              className="flex flex-row items-center gap-2 h-fit hover:bg-white bg-[#503691] border border-[#503691] text-white hover:text-[#503691] px-6 py-1.5 rounded-lg cursor-pointer"
              onClick={() => handleShareClick(property)}
            >
              <FaShareAlt className="h-4 w-4" />
              Share
            </div>
          )}

          {/* Owner-only "+" that adds photos, sitting left of the Media button */}
          {ownerView && (
            <OwnerAddMediaButton
              property={property}
              onUploaded={onMediaUpdated}
              className="h-fit w-full py-1.5"
            />
          )}

          {/* Only show Photos button if not in requirements path */}
          {!isRequirementPath &&
            (property?.images?.length > 0 ||
              (isSpecialPath && property?.media?.length > 0) ? (
              <Photos_Video
                images={
                  isSpecialPath
                    ? property?.media?.map((item) => item.url) || []
                    : property.images?.length > 0
                      ? property.images[0].includes(",")
                        ? property.images[0].split(",")
                        : property.images
                      : []
                }
              />
            ) : (
              <div className="flex items-center gap-2 bg-gray-100 hover:bg-white text-gray-400 hover:text-blue-800 border border-gray-300 px-3 py-1.5 rounded-lg cursor-not-allowed">
                <FaCameraRetro className="h-4 w-4 text-gray-400" />
                Media
              </div>
            ))}

          {/* Edit Property Button (owner dashboard only) */}
          {ownerView && onEdit && (
            <div
              className="flex flex-row items-center justify-center gap-2 h-fit hover:bg-white bg-[#503691] border border-[#503691] text-white hover:text-[#503691] px-4 py-1.5 rounded-lg cursor-pointer"
              onClick={() => onEdit(property)}
            >
              <FaRegEdit className="h-4 w-4" />
              Edit
            </div>
          )}

          {/* Save Button */}
          {!ownerView && (
            <div
              className={`flex flex-row items-center gap-2 h-fit ${isSaved
                  ? "bg-white text-[#503691]"
                  : "bg-white text-[#503691] hover:bg-[#503691] hover:text-white"
                } border border-[#503691] px-6 py-1.5 rounded-lg cursor-pointer`}
              onClick={handleSaveClick}
            >
              {isSaved ? (
                <FaBookmark className="h-4 w-4" />
              ) : (
                <FaRegBookmark className="h-4 w-4" />
              )}
              {isSaved ? "Unsave" : "Save"}
            </div>
          )}
        </div>
      </div>

      {/* Owner dashboard status toggle (mobile) */}
      {ownerView && (
        <div className="flex flex-col lg:hidden mt-3 gap-2">
          <div className="w-full px-3 py-2 rounded-lg mb-2 bg-white border border-gray-200 flex justify-between items-center gap-2">
            <p className="text-sm font-semibold text-gray-700">Property Status</p>
            <OwnerStatusControl property={property} onUpdated={onStatusUpdated} />
          </div>

          {property?.dailyContact !== undefined && (
            <p className="text-xs text-gray-600 -mt-1 mb-1">
              {property?.dailyContact} people contacted this property today
            </p>
          )}
        </div>
      )}

      <div className={`${ownerView ? "hidden" : "flex"} flex-col lg:hidden mt-3 gap-2`}>
        {contactInfoMap[property._id] ? (
          <div
            className="w-full px-2 py-2 rounded-lg mb-2 bg-white border border-[#503691] text-[#503691] flex justify-between items-center"
            onClick={(e) => e.stopPropagation()} // Prevent unwanted parent click
          >
            {/* Name */}
            <div>
              <p className="font-semibold">
                {contactInfoMap[property._id]?.name || "NA"}
              </p>
            </div>

            {/* Contact Number with WhatsApp */}
            <div className="flex items-center gap-4">
              {/* Phone Icon (clickable) */}
              <a
                href={`tel:${typeof contactInfoMap[property._id]?.number === "string" &&
                    contactInfoMap[property._id]?.number.startsWith("+91")
                    ? contactInfoMap[property._id]?.number
                      .replace("+91", "")
                      .trim()
                    : contactInfoMap[property._id]?.number || ""
                  }`}
                className="text-[#503691] hover:text-blue-600 transition-colors"
                title="Call"
                onClick={(e) => e.stopPropagation()} // Prevent container click propagation
              >
                <MdOutlinePhone className="h-5 w-5" />
              </a>

              {/* Show Number (non-clickable text) */}
              <span className="text-sm font-medium">
                {contactInfoMap[property._id]?.number || "NA"}
              </span>

              {/* WhatsApp Icon */}
              <a
                href={`https://wa.me/${typeof contactInfoMap[property._id]?.number === "string" &&
                    contactInfoMap[property._id]?.number.startsWith("+91")
                    ? contactInfoMap[property._id]?.number.replace("+91", "").trim()
                    : contactInfoMap[property._id]?.number || ""
                  }?text=${encodeURIComponent(
                    getWhatsAppMessage(property, contactInfoMap[property._id])
                  )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform p-1 rounded-full hover:bg-green-100"
                title="WhatsApp"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  className="h-8 w-8"
                  fill="#25D366"
                >
                  <path d="M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z" />
                </svg>
              </a>
            </div>
          </div>
        ) : (
          <button
            onClick={handleGetContact}
            className="w-full px-2 py-1 rounded-lg mb-2 hover:bg-white bg-[#503691] border border-[#503691] text-white hover:text-[#503691]"
            disabled={loading}
          >
            {loading ? "Loading..." : "Get Contact Number"}
          </button>
        )}
        {property?.dailyContact !== undefined && (
          <p className=" text-[14px] font-bold text-gray-600 text-center">
            {property?.dailyContact} people contacted this property today
          </p>
        )}
      </div>

      {/* Remark Section for Mobile View */}
      {!ownerView && (
        <div className="lg:hidden">
          {/* <div className="flex gap-4">
              <div className="flex flex-row items-center">
                <RxDimensions className="text-[#f1d35c] mr-2 h-6 w-6" />
                <p>Sqft</p>
              </div>
              <p className="text-end">{property?.squareFt || "NA"} sqft</p>
            </div> */}
          <div className="flex items-center justify-between gap-4">
            <div className="flex flex-row items-center">
              <MdNoteAlt className="text-[#503691] mr-2 h-5 w-5" />
              <p className="text-sm font-medium text-[#503691]">Remark</p>
            </div>
            <div className="flex flex-col gap-2 bg-white p-3">
              {isEditing ? (
                <div className="flex flex-row gap-2 items-center">
                  <input
                    type="text"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    className="border border-gray-300 rounded p-2 w-full text-sm focus:outline-none focus:ring-1 focus:ring-[#503691]"
                    placeholder="Enter your remark here"
                  />
                  <AiOutlineCheck
                    className="text-green-500 cursor-pointer"
                    onClick={handleSaveRemark}
                  />
                  <AiOutlineClose
                    className="text-red-500 cursor-pointer"
                    onClick={handleCancelEdit}
                  />
                  {/* <div className="flex justify-end gap-2">
                    <button
                      className="px-4 py-1 text-sm bg-green-500 text-white rounded hover:bg-green-600"
                      onClick={handleSaveRemark}
                    >
                      Save
                    </button>
                    <button
                      className="px-4 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                      onClick={handleCancelEdit}
                    >
                      Cancel
                    </button>
                  </div> */}
                </div>
              ) : (
                <div className="flex flex-row gap-2">
                  <p className="text-sm text-gray-600">
                    {remark || "No remarks added yet."}
                  </p>
                  <button
                    className="text-sm text-blue-500 hover:underline self-end"
                    onClick={() => setIsEditing(true)}
                  >
                    Edit
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Owner support pill: one tap to raise an issue about this listing */}
      {ownerView && (
        <div className="mt-0.5 flex justify-center sm:justify-end">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#25D366]/40 bg-[#25D366]/5 py-1 pl-3 pr-1 sm:gap-3 sm:pl-4">
            <p className="text-[14px] text-gray-700 sm:text-xs">
              To update uneditable details, contact admin
            </p>
            <a
              href={supportWhatsAppLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-[#25D366] px-3 py-1.5 text-[11px] font-semibold text-white shadow-sm transition-colors hover:bg-[#1da851] sm:text-xs"
            >
              <WhatsAppIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" fill="#ffffff" />
              WhatsApp
            </a>
          </div>
        </div>
      )}

      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareText={currentShareText}
      />
    </div>
  );
}

export default List;
